// extracted by mini-css-extract-plugin
export default {"searchWrapper":"searchInput_searchWrapper__KairI","searchBar":"searchInput_searchBar__50-MV","searchIcon":"searchInput_searchIcon__Fh7Kv","btnSubmit":"searchInput_btnSubmit__h3rzr"};